module.exports = __webpack_public_path__ + "img/img_clients9.892552af.jpg";